import { jwtDecode } from "jwt-decode";
import { PropsWithChildren, useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import jsonpath from "jsonpath"
import { LoginRedirect } from "./LoginRedirect";
import { LoadingScreen } from "./LoadingScreen";
import { useTranslation } from "react-i18next";
import { Error401 } from "../pages/errors";
import { ErrorLoginState } from "../pages/errors/errorLoginState";

export interface AuthenticatedGuardProps extends PropsWithChildren {
    role_claim_json_path: string
    required_roles: string
}

export function AuthenticatedGuard({
    children,
    role_claim_json_path = "roles",
    required_roles = "",
}: AuthenticatedGuardProps): JSX.Element {

    const { t } = useTranslation()
    const auth = useAuth();
    const [decoded, setDecoded] = useState<Record<string, any> | null>(null);
    const [hasAccess, setHasAccess] = useState<boolean>(false)
    const [requiredRoles, setRequiredRoles] = useState<string[]>([]);

    useEffect(() => {
        if (auth?.isAuthenticated && auth.user?.access_token) {
            const accessToken = auth.user.access_token;
            setDecoded(jwtDecode(accessToken));
            setRequiredRoles(required_roles.split(",").filter((e) => e));
        }
    }, [auth]);


    useEffect(() => {
        if (decoded && requiredRoles?.length > 0 && role_claim_json_path) {
            try {
                const currentRoles = jsonpath.query(decoded, role_claim_json_path)?.[0] || [];
                // console.log("===>", role_claim_json_path, decoded)
                // console.log("===>", requiredRoles)
                if (!currentRoles?.length) {
                    return;
                }
                const decodedRolesMap = currentRoles.reduce((map: { [x: string]: boolean; }, role: string | number) => {
                    map[role] = true;
                    return map;
                }, {});

                // console.log("===>", decodedRolesMap)
                // console.log("===>", requiredRoles)
                for (const role of requiredRoles) {
                    if (decodedRolesMap[role]) {
                        setHasAccess(true);
                        return;
                    }
                }
                return;
            } catch (error) {
                console.error(error);
                return;
            }
        } else if (decoded && !requiredRoles?.length) {
            setHasAccess(true);
            return;
        }
    }, [requiredRoles, decoded, role_claim_json_path]);


    return <>

        {auth?.activeNavigator === 'signinSilent' ?
            <LoadingScreen message={t("core:authGuard.signinSilent.message")} />
            : null}
        {auth?.activeNavigator === 'signoutRedirect' ?
            <LoadingScreen message={t("core:authGuard.signoutRedirect.message")} />
            : null}
        {auth?.isLoading ?
            <LoadingScreen message={t("core:authGuard.isLoading.message")} />
            : null}
        {auth?.error ?
            <div className="d-flex absolute top-0 left-0 right-0 bottom-0 w-full">
                <ErrorLoginState />
            </div>
            : null}
        {!auth.isAuthenticated && auth.activeNavigator !== "signinSilent" && auth.activeNavigator !== 'signoutRedirect' && !auth.isLoading && !auth.error ?
            <LoginRedirect /> :
            null}
        {auth.isAuthenticated && hasAccess ? children : null}
        {auth.isAuthenticated && !hasAccess ? <Error401 /> : null}

    </>

}




